// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3v9X9","right":"styles_right__3e4to"};